import moment from 'moment'
import * as React from 'react'
import ReactSelect from 'react-select'
import styled, { AnyStyledComponent } from 'styled-components'
import { LOGIC_UNIT } from '.'
import I18n from '../../../../core/i18n'
import { adminService, utilService } from '../../../../core/services'
import { COLORS, BREAKPOINT_TABLET_SMALL } from '../../../../static/constants'
import { InputDate, InputRadio, InputText } from '../../../atoms'
import AdminLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  comment: 'comment',
  expire_at: 'expire_at',
  logic_type: 'logic_type',
  logic_value: 'logic_value',
  limit: 'limit',
  usage: 'usage',
}
const OPTIONS = [
  { id: '0', label: 'Price discount', value: 'fixed' },
  { id: '1', label: 'Percentage discount', value: 'percentage' },
]
const title = I18n.t('admin.create_new', {
  model: I18n.t('coupon', { scope: 'activerecord.models' }),
})
const selectCustomStyles = {
  control: (provided, state) => ({
    ...provided,
    border: `1px solid ${COLORS.divider}`,
    borderRadius: 4,
    '&:hover': { border: `1px solid ${COLORS.primary}` },
  }),
  multiValue: (styles, { data }) => ({
    ...styles,
    backgroundColor: COLORS.primary,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: COLORS.white,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: COLORS.white,
  }),
}
const AdminCouponNew: React.FC<{ categories: any }> = props => {
  const { data: couponCategories } = utilService.getDataFromJson(props.categories)
  const [logicLabel, setLogicLabel] = React.useState<string>(LOGIC_UNIT.fixed)
  const [selectedCategories, setSelectedCategories] = React.useState(null)
  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const result = { ...values }
      result.category_ids = selectedCategories?.map(category => Number(category.value))
      const { createdCoupon, flush } = await adminService.createCoupon(result)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/admin/coupons'
    },
    [selectedCategories]
  )
  const handleCalendarOutSideRange = React.useCallback(calendarMoment => {
    return calendarMoment.isBefore(moment())
  }, [])

  return (
    <AdminLayoutNew
      model="coupon"
      title={title}
      fields={FIELDS}
      indexLink="/admin/coupons"
      formItems={
        <>
          <InputText
            required={true}
            name="name"
            defaultValue=""
            label="Name"
            placeholder="coupon code, ex. YT202008"
          />
          <InputText
            required={false}
            name="comment"
            defaultValue=""
            label="Comment"
            placeholder="ex. Youtube Aug"
          />
          <S.ReactSelectWrapper>
            <p className="ReactSelect_Title">Category</p>
            <div className="ReactSelect_Main">
              <ReactSelect
                placeholder="Select Category"
                options={couponCategories.map(category => ({
                  value: category.id,
                  label: category.name,
                }))}
                isMulti={true}
                onChange={setSelectedCategories}
                styles={selectCustomStyles}
                menuPortalTarget={document.querySelector('body')}
              />
            </div>
          </S.ReactSelectWrapper>
          <InputDate
            name="expire_at"
            defaultValue=""
            label="Expire"
            required={true}
            isOutsideRange={handleCalendarOutSideRange}
          />
          <InputText required={true} name="limit" defaultValue="" label="Limit" />
          <S.LogicWrap>
            <p className="Logic_Title">Logic</p>
            <div className="Logic_InputWrapper">
              <div className="Logic_Input">
                <span className="Logic_Label">Type: </span>
                <InputRadio
                  required={true}
                  directionRow={true}
                  name="logic_type"
                  options={OPTIONS}
                  defaultValue="fixed"
                  onChangeHandler={e => {
                    setLogicLabel(LOGIC_UNIT[e.target.value])
                  }}
                />
              </div>
              <div className="Logic_Input">
                <span className="Logic_Label">Value: </span>
                <InputText required={true} name="logic_value" defaultValue="" />
                <span className="Logic_Unit"> {logicLabel}</span>
              </div>
            </div>
          </S.LogicWrap>
          <InputText required={true} readonly={true} name="usage" defaultValue="0" label="Usage" />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.LogicWrap = styled.div`
  display: flex;
  margin: 24px 0;
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .Logic_Title {
    min-width: 240px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;

    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .Logic_InputWrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    .Logic_Input {
      display: flex;
      align-items: center;
    }
    .Logic_Label {
      width: 64px;
    }
    .Logic_Unit {
      margin-left: 8px;
    }
  }
`

S.ReactSelectWrapper = styled.div`
  display: flex;
  margin-top: 24px;
  @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .ReactSelect_Title {
    min-width: 240px;
    font-size: 15px;
    font-weight: bold;
    line-height: 1;
    margin-top: 8px;

    @media (max-width: ${BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .ReactSelect_Main {
    flex: 1;
    font-size: 15px;
  }
`

export default AdminCouponNew
